import type { FC } from 'react';
import { useContext } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import { SubSubNavBarProps } from './types';
import SubSubNavBarMobile from './Mobile';
import SubSubNavBarDesktop from './Desktop';

const SubSubNavBar: FC<SubSubNavBarProps> = props => {
  const isMobile = useContext(MobileContext);
  const mindTheGap = useFlag('mind_the_gap');

  return (
    <ErrorBoundary hideOnFail debugComponent="SubSubNavBar">
      {isMobile ? (
        <SubSubNavBarMobile {...props} mindTheGap={mindTheGap} />
      ) : (
        <SubSubNavBarDesktop {...props} mindTheGap={mindTheGap} />
      )}
    </ErrorBoundary>
  );
};
SubSubNavBar.displayName = 'SubSubNavBar';

export default SubSubNavBar;
